import { checkName, checkNotEmpty, checkDate } from '~h/validators';

export const signerFormInputs = [
  {
    name: 'lastName',
    label: 'Фамилия подписанта',
    type: 'text',
    required: true,
    error: false,
    validator: checkName,
  },
  {
    name: 'name',
    label: 'Имя подписанта',
    type: 'text',
    required: true,
    error: false,
    validator: checkName,
  },
  {
    name: 'patronymic',
    label: 'Отчество подписанта',
    type: 'text',
    required: true,
    error: false,
    validator: checkName,
  },
  {
    name: 'companyPosition',
    label: 'Должность подписанта',
    type: 'text',
    required: true,
    error: false,
    validator: checkNotEmpty,
  },
  {
    name: 'basis',
    label: 'Основание для подписи',
    type: 'select',
    options: [
      { 
        value: 'Доверенность', 
        label: 'Доверенность', 
        fields: [
          {
            name: 'proxyDate',
            label: 'Дата выдачи доверенности',
            type: 'date',
            required: true,
            error: false,
            validator: checkDate,
          },
          {
            name: 'proxyNum',
            label: 'Номер доверенности',
            type: 'text',
            required: true,
            error: false,
            validator: checkNotEmpty,
          },
        ] 
      },
      { value: 'Устав', label: 'Устав' },
    ],
    required: true,
    error: false,
    validator: checkNotEmpty,
  },
];